<template>
  <div class="dateMessageMain" :class="{'flex-end':$store.state.session.user.UserID === message.From}">
    <div class="dateMessage messageTextContainer">
      {{ interpretedDateMessage(message) }}
    </div>
  </div>
</template>

<script>
import { messageMixin } from '@/mixins/messageMixin.js'

export default {
  props: {
    message: {
      type: Object,
      default: function () {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  mixins: [messageMixin]
}
</script>

<style scoped>
.dateMessageMain {
  display: flex;
  justify-content: center;
  margin-bottom: 5px;
}

.dateMessage {
  background-color: #e8eaf6;
  border: 1px solid #c5cae9;
  font-size: 11px;
  padding: 7px;
  border-radius: 5px;
  margin-top: 15px;
}
</style>
